import styled from "styled-components";

export const ContactDetailsDataTableContainer = styled.div`
    .productDetailInputMain{
        input{
            height: 31px;
        }
    }
    .pro{margin-top:6px;}
`;